import hljs from 'highlight.js/lib/core';
import 'highlight.js/styles/github.css';

import javascript from 'highlight.js/lib/languages/javascript';
import css from 'highlight.js/lib/languages/css';
import sql from 'highlight.js/lib/languages/sql';
import csharp from 'highlight.js/lib/languages/csharp';
import php from 'highlight.js/lib/languages/php';

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('css', css);
hljs.registerLanguage('sql', sql);
hljs.registerLanguage('csharp', csharp);
hljs.registerLanguage('php', php);

const init = () => {
  const highLightCodeList = [...document.querySelectorAll('.js-highlightcode')];
  if (highLightCodeList.length) {
    highLightCodeList.forEach(el => {
      hljs.highlightElement(el);
    });
  }
}

const loadHighlight = {
  init,
};

export default loadHighlight;
